"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("../App.css");
var _Shortcuts = _interopRequireDefault(require("./Shortcuts"));
var _Headers = _interopRequireDefault(require("./Headers"));
var _reactRedux = require("react-redux");
var _actions = require("../actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = state => ({
  state: state.apitester
});
const mapDispatchToProps = dispatch => ({
  handleChangeUrl: e => dispatch((0, _actions.handleChangeUrl)(e)),
  handleChangeHttpMethod: e => dispatch((0, _actions.handleChangeHttpMethod)(e)),
  handleChangeBody: e => dispatch((0, _actions.handleChangeBody)(e)),
  request: (requestParams, headers) => dispatch((0, _actions.request)(requestParams, headers))
});
function Form(props) {
  function handleSubmitApi(e) {
    if (e) e.preventDefault();
    if (!props.state.body || isJsonString(props.state.body) === true) {
      if (duplicateHeadersInState()) {
        throw "Duplicate headers";
      }
      let requestParams = {
        baseURL: props.state.baseUrl,
        url: props.state.endpoint,
        method: props.state.httpMethod,
        data: props.state.body
      };
      let headers = props.state.headers;
      props.request(requestParams, headers);
    } else {
      document.getElementById("response").innerHTML = "Error: body is not valid JSON";
    }
  }
  function isJsonString(str) {
    /**
     * Checks is the string is a valid JSON string. Returns 'true' or 'false'.
     */

    try {
      JSON.parse(str);
    } catch (err) {
      console.dir(err);
      return false;
    }
    return true;
  }
  function duplicateHeadersInState() {
    /**
     * Looks for duplicate headers in the state and returns true or false.
     */

    let headers = [...props.state.headers];
    let keys = headers.map(function (item) {
      if (item.headerKey.length !== 0) return item.headerKey;
    });
    let isDuplicate = keys.some(function (item, idx) {
      if (item != undefined) return keys.indexOf(item) !== idx;
    });
    return isDuplicate;
  }
  function handleKeyDown(e) {
    const code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      // 'Enter' key pressed

      e.preventDefault();
      handleSubmitApi(e);
    } else props.handleChangeUrl(e);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "content "
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => handleSubmitApi(e)
  }, /*#__PURE__*/_react.default.createElement(_Shortcuts.default, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-8 colMargin"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    value: props.state.endpoint,
    onKeyDown: e => handleKeyDown(e),
    onChange: e => handleKeyDown(e),
    type: "text",
    className: "form-control",
    id: "url",
    placeholder: "URL"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-7 colMargin"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement("select", {
    value: props.state.httpMethod,
    className: "form-control",
    id: "httpMethod",
    onChange: e => props.handleChangeHttpMethod(e)
  }, /*#__PURE__*/_react.default.createElement("option", {
    defaultValue: true,
    value: "GET"
  }, "GET"), /*#__PURE__*/_react.default.createElement("option", {
    value: "PUT"
  }, "PUT"), /*#__PURE__*/_react.default.createElement("option", {
    value: "POST"
  }, "POST"), /*#__PURE__*/_react.default.createElement("option", {
    value: "DELETE"
  }, "DELETE"), /*#__PURE__*/_react.default.createElement("option", {
    disabled: true
  }, "\u2500\u2500\u2500"), /*#__PURE__*/_react.default.createElement("option", {
    value: "HEAD"
  }, "HEAD"), /*#__PURE__*/_react.default.createElement("option", {
    value: "TRACE"
  }, "TRACE"), /*#__PURE__*/_react.default.createElement("option", {
    value: "PATCH"
  }, "PATCH"), /*#__PURE__*/_react.default.createElement("option", {
    value: "OPTIONS"
  }, "OPTIONS"), /*#__PURE__*/_react.default.createElement("option", {
    value: "CONNECT"
  }, "CONNECT")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-5 colMargin"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    type: "submit",
    id: "submitButton",
    disabled: true
  }, "Send"))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg bordered"
  }, /*#__PURE__*/_react.default.createElement(_Headers.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg colMargin bordered"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Body"), /*#__PURE__*/_react.default.createElement("textarea", {
    value: props.state.body,
    onChange: props.handleChangeBody,
    rows: "6",
    className: "form-control",
    id: "body"
  })))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "row colMargin"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row response-title justify-content-between colMargin"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Response")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-auto"
  }, /*#__PURE__*/_react.default.createElement("h5", {
    id: "status"
  }, " "))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("pre", {
    id: "response"
  })))))));
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Form);
module.exports = exports.default;